import dayjs from 'dayjs';
import type { ManipulateType } from 'dayjs';

import {
  TIME_RANGE_PRESET_SUFFIX,
  TIME_RANGE_PRESETS,
  TIME_STAMP_FORMAT,
} from '@/shared/components/ui/filters/time-range-filter/time-range-filter.constants';
import {
  TSubtract,
  TTimeRangePreset,
} from '@/shared/components/ui/filters/time-range-filter/time-range-filter.types';
import { BETWEEN_SEPARATOR } from '@/shared/filters/filter-builder.constants';

export const subtractRange = (from: Date, subtract: TSubtract) =>
  (Object.entries(subtract) as Array<[ManipulateType, number]>).reduce(
    (date, [unit, value]) => dayjs(date).subtract(value, unit).toDate(),
    from,
  );

export const formatTimeRangeParam = (start: Date, end: Date) =>
  `${dayjs(start).utc().format(TIME_STAMP_FORMAT)}${BETWEEN_SEPARATOR}${dayjs(end).utc().format(TIME_STAMP_FORMAT)}`;

export const findTimeRangePreset = (
  id: string | null,
): TTimeRangePreset | undefined =>
  TIME_RANGE_PRESETS.find((preset) => preset.id === id);

// A preset is relative, so a remembered one restores against now rather than the moment it was picked.
export const refreshTimeRangePresets = (
  params: URLSearchParams,
): URLSearchParams => {
  const next = new URLSearchParams(params);
  const now = new Date();

  params.forEach((value, key) => {
    const preset = findTimeRangePreset(value);
    if (!preset || !key.endsWith(TIME_RANGE_PRESET_SUFFIX)) {
      return;
    }

    next.set(
      key.slice(0, -TIME_RANGE_PRESET_SUFFIX.length),
      formatTimeRangeParam(subtractRange(now, preset.subtract), now),
    );
  });

  return next;
};
